import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { AuthSliceType, createAuthSliceType } from './authSlice';

export const useAppStore = create<AuthSliceType>()(
    devtools(
        (...a) => ({
            ...createAuthSliceType(...a)
        }),
        {
            name: 'ranking-objetivos-store',
            enabled: process.env.REACT_APP_ENVIRONMENT === "DEV"
        }
    )
)